export const isSSR = ()=>"object" === "undefined";
export default isSSR;
